import React from "react";
import { Link } from "react-router-dom";
import SlideUpAnimation from "../../components/SlideUpAnimation/SlideUpAnimation";

const CARDS = [
  {
    title: "Live smarter",
    body: "Every listing includes an affordability calculator, Plan my day commute map, and a full cost-of-living breakdown — so you can judge a home before you visit.",
    tags: ["Affordability", "Plan my day", "Cost of living"],
  },
  {
    title: "Know the neighbourhood",
    body: "Explore what is around each property — coffee, food, shops, transport, schools, and more — with neighbourhood intel built into every listing page.",
    tags: ["Coffee & food", "Shops", "Transport", "Schools"],
  },
];

const ListingIntelligenceSection: React.FC = () => {
  return (
    <section className="bg-bg-porcelain py-16 md:py-20 border-y border-solid border-[rgba(0,0,0,0.06)]">
      <div className="max-w-[1440px] mx-auto px-[5%]">
        <div className="mb-10 pl-4 border-l-4 border-l-solid border-l-brand-yellow">
          <SlideUpAnimation triggerOnce>
            <span className="font-manrope text-xs tracking-wider uppercase text-text-slate block mb-2">
              On every listing
            </span>
            <h2 className="page-section-heading mb-2">
              Smarter property decisions
            </h2>
            <p className="font-manrope text-sm text-text-slate max-w-2xl">
              Tools and local insight to help you understand the true cost and
              convenience of living somewhere — not just the rent.
            </p>
          </SlideUpAnimation>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {CARDS.map((card, index) => (
            <SlideUpAnimation key={card.title} triggerOnce delay={index * 0.15}>
              <div className="h-full bg-bg-white border border-solid border-[rgba(0,0,0,0.06)] shadow-soft p-6 flex flex-col">
                <h3 className="font-teko text-2xl text-text-obsidian mb-3">
                  {card.title}
                </h3>
                <p className="font-manrope text-sm text-text-slate leading-relaxed mb-4 flex-1">
                  {card.body}
                </p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {card.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs font-manrope uppercase tracking-wider bg-bg-porcelain px-3 py-1 border border-solid border-[rgba(0,0,0,0.08)]"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </SlideUpAnimation>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/services/rent"
            className="inline-block font-teko text-lg uppercase px-8 py-3 bg-text-obsidian text-white hover:bg-brand-yellow hover:text-text-obsidian transition"
          >
            Browse listings
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ListingIntelligenceSection;
